module.exports = __webpack_public_path__ + "img/visao-3.4c94e28a.jpg";